import Button from "@acko-tech/building-blocks.ui.button-old";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const AddOnCardWrapper = styled(Box)`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #efe9fb;
  background: #fff;
  box-sizing: border-box;
  margin-top: 16px;
`;

export const CardHeading = styled(Text)`
  padding: 16px 16px 0px 16px;
  color: var(--text-primary-n-600, #040222);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  @media (min-width: 768px) {
    line-height: 24px;
    font-size: 16px;
  }
`;

export const CardSubHeading = styled(Text)`
  padding: 4px 20px 0px 16px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: var(--text-secondary-n-400, #5b5675);

  ul {
    padding-inline-start: 15px;
    margin-block-start: 4px;
  }
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const AddOnCardBottomContainer = styled(Flex)`
  width: auto;
  padding: 6px 16px;
  background: #f9f6ff;
  margin-top: 12px;
  justify-content: space-between;
  border-radius: 0px 0px 12px 12px;
  height: 44px;
  align-items: center;
`;
export const AddOnCardBottonText = styled(Text)`
  color: #040222;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;

  span {
    font-size: 14px;
    font-weight: 600;
  }

  @media (min-width: 768px) {
    span {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }

    font-size: 14px;
    line-height: 20px;
  }
`;
export const AddOnCardButton = styled(Button)`
  background: #f9f6ff;
  padding: 8px 12px;
  border: 1px solid #040222;
  color: #040222;
  height: 36px;
  width: 96px;
  font-size: 16px;
  font-weight: 600;
  line-height: 32px;
  font-family: "Euclid Circular B";
   position: relative;
  :hover {
    border: 1px solid var(--Neutral-N600, #040222);
    background-color: ${({ isSelected }) => {
    return isSelected ? "#040222;" : "#F9F6FF";
  }};
    color: ${({ isSelected }) => {
    return isSelected ? "#FFF;" : "#040222";

  }};
  }
  @media (max-width: 768px) {
    width: 69px;
    height: 32px;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }

  background-color: ${({ isSelected }) => {
    return isSelected ? "#040222" : "#F9F6FF";
  }};

  color: ${({ isSelected }) => {
    return isSelected ? "#FFF" : "#040222";
  }};
`;

export const CardTag = styled(Flex)`
  text-align: center;
  padding: 0px;
  color: #d83d37;
  border-radius: 24px;
  background: #fbeaea;
  margin: 12px 0px 0px 16px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  box-sizing: border-box;
  width: 110px;
  height: 26px;

  @media (min-width: 768px) {
    width: 127px;
    height: 30px;
    font-size: 12px;
    line-height: 18px;
    padding: 6px 12px;
  }
`;

export const StyledListItem = styled.li`
  margin-top: 4px;
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const OptionsLabel = styled.p`
  position: absolute;
  right: 10%;
  top: 38%;
  color: #5B5675;
  background-color: #F9F6FF;
  padding: 0px 4px;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;

  @media(min-width: 768px){
    right: 18%;
    top: 32%;
    font-size: 12px;
    line-height: 18px;
  }
  
`;
